import React, { useEffect, useState } from 'react';
import { Modal,Button } from 'react-bootstrap';
import './index.css';

const OptionModal = ({ showOptionModal, onCancel, onSubmit, options, columnInfo }) => {
  
  
  const [option, setOption] = useState(['']);
  useEffect(() => {
    if (options) {
      setOption(options);
    }
  }, [])
  // console.log(option,options);

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      width: '50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  const addOptionRow = () => {
    let newOptions = [...option];
    if (newOptions && newOptions.length > 0) {
      newOptions.push('');
      setOption(newOptions);
    }
  }

  const handleInputChange = (optionz, index) => {
    const options = [...option];
    options.splice(index, 1, optionz);
    setOption(options);
  }

  const handleOptionRemove = (index) => {
    const options = [...option];
    options.splice(index, 1);
    if (!options.length) {
      options.push('');
    }
    setOption(options);
  }

  const renderOptionRow = (option, optionIndex) => {
    const onOptionChange = (e) => {
      let newOption = e.target.value;
      handleInputChange(newOption, optionIndex);
    };

    const onRemove = () => {
      handleOptionRemove(optionIndex);
    };

    return (
      <div className="form-control option" key={optionIndex}>
        <input
          type="text"
          className="input-option"
          value={option}
          placeholder="Enter Option"
          onChange={(e) => onOptionChange(e)}
        />
        <div className="option__actions">
          <Button type="button" className="btn btn--link" onClick={onRemove}>
            Remove
          </Button>
        </div>
      </div>
    );
  }

  return (
    <Modal show={showOptionModal} onHide={onCancel} className={'theme-modal'} style={customStyles} id={''} size={'md'}>
      <Modal.Header closeButton>
        <Modal.Title><h3>Add Options</h3></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{option.map(renderOptionRow)}</div>
      </Modal.Body>
      <Modal.Footer>
        <div className="modal__footer">
          <Button type="button" className="btn btn--primary" onClick={addOptionRow}>
            Add Option
          </Button>
          
          <Button
            type="button" className="btn btn--primary" onClick={() => onSubmit(option, columnInfo)}
          >
            Submit
          </Button>
          <Button type="button" className="btn btn--primary" onClick={onCancel}>
            Close
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
export default OptionModal;